/** Retrieve a CSS custom property, falling back when missing */
export function getCssVar(name: string, fallback: string): string {
    return (
        getComputedStyle(document.body).getPropertyValue(name).trim() || fallback
    );
}
